import { render, staticRenderFns } from "./UpdateGroupClassLinkDialog.vue?vue&type=template&id=a7534ed8&scoped=true"
import script from "./UpdateGroupClassLinkDialog.vue?vue&type=script&lang=js"
export * from "./UpdateGroupClassLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateGroupClassLinkDialog.vue?vue&type=style&index=0&id=a7534ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7534ed8",
  null
  
)

export default component.exports